export enum EEnvironment {
  development = 'development',
  e2e = 'e2e',
  testserver = 'testserver',
  integration = 'integration',
  staging = 'staging',
  production = 'production',
}
